<template>
  <aside class="nav-aside" :class="{ 'is-active--aside': this.isActiveAside }">
    <div class="nav-aside__block">
      <h3 class="nav-aside__label">
        <a href="/" class="nav-aside__a">
          <icon-logo-typo class="icon icon--typo" />
          <span class="a11y">fastcampus 홈으로</span>
        </a>
      </h3>
      <a href="/" class="nav-aside__home" title="홈으로"><icon-home class="icon icon--home" /></a>
      <button type="button" class="nav-aside__close" @click="toggleHolder">
        <icon-close class="icon icon--close" />
      </button>

      <icon-logo-symbol class="icon icon--circle" />
    </div>
  </aside>
</template>

<script>
import IconLogoTypo from '../components/icons/logo-typo.svg';

import IconHome from '../components/icons/home.svg';
import IconClose from '../components/icons/close.svg';
import IconLogoSymbol from '../components/icons/logo-symbol.svg';

export default {
  props: ['is-active-aside'],
  components: {
    IconLogoTypo,
    IconHome,
    IconClose,
    IconLogoSymbol,
  },
  methods: {
    toggleHolder() {
      this.$emit('emit-holder');
    },
  },
};
</script>
